import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/svg/CantUseFeature/header.svg?webp&width=500'
import _imports_1 from '@/assets/svg/CantUseFeature/point.svg'
import _imports_2 from '@/assets/svg/CantUseFeature/flow.svg?webp&width=500'


const _withScopeId = n => (_pushScopeId("data-v-3fcf8f21"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "w-100 h-100 pb-4 mx-auto bg-white" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "d-flex justify-content-center" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    class: "svg-image"
  })
], -1))
const _hoisted_3 = { class: "p-3" }
const _hoisted_4 = { class: "cant-use-feature-content mb-4" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "d-flex justify-content-center" }, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_1 })
], -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mt-4 mb-1" }, "\n            お仕事が見つかった時、すぐ応募できるようにアカウント登録を行いましょう！\n          ", -1))
const _hoisted_7 = { class: "d-flex justify-content-center" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "d-flex justify-content-center" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_2,
    class: "svg-image"
  })
], -1))
const _hoisted_9 = { class: "d-flex justify-content-center" }

import AppButton from "@/components/atoms/button/AppButton.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'CantUseFeature',
  setup(__props) {

const mypageRoute = {
  name: "Mypage"
};

return (_ctx: any,_cache: any) => {
  const _component_SvgFlow = _resolveComponent("SvgFlow")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createTextVNode(),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        _createTextVNode(),
        _createElementVNode("div", null, [
          _hoisted_6,
          _createTextVNode(),
          _createElementVNode("div", _hoisted_7, [
            _createVNode(_component_SvgFlow)
          ]),
          _createTextVNode(),
          _hoisted_8
        ])
      ]),
      _createTextVNode(),
      _createElementVNode("div", _hoisted_9, [
        _createVNode(AppButton, {
          to: mypageRoute,
          class: "w-100"
        }, {
          default: _withCtx(() => [
            _createTextVNode("\n          アカウント登録に進む\n        ")
          ], undefined, true),
          _: 1
        })
      ])
    ])
  ]))
}
}

})